// extracted by mini-css-extract-plugin
export default {"wrapper":"ScriptsCount_wrapper__dvXsM","title":"ScriptsCount_title__M+ri2","count":"ScriptsCount_count__V5rfC"};